import React, { ReactNode } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const GoogleCaptcha = ({ children }: { children: ReactNode }) => {
  const recaptchaKey = process.env.GATSBY_RECAPTCHA_SITE_KEY as string
  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>
      {children}
    </GoogleReCaptchaProvider>
  )
}

export default GoogleCaptcha